import { reputationList } from "@/mocks/nanaData";

export default function About() {
  return (
    <section id="about" className="px-4 py-14 md:px-6 md:py-16" aria-label="关于我们">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="relative">
            <div className="absolute -left-4 -top-4 h-24 w-24 rounded-2xl bg-accent-100"></div>
            <img
              src="https://readdy.ai/api/search-image?query=warm%20illustration%20of%20a%20cozy%20online%20community%20hub%20with%20people%20and%20floating%20news%20cards%2C%20coral%20amber%20cream%20flat%20vector%2C%20friendly%20brand%20story%20mood%2C%20soft%20shadows&width=1000&height=720&seq=about-img&orientation=portrait"
              alt="娜娜51热评圈 - 关于我们的品牌插画"
              className="relative rounded-3xl object-cover"
            />
            <div className="absolute -bottom-5 -right-3 rounded-2xl bg-primary-500 px-5 py-4 text-background-50">
              <p className="font-[ZCOOL_KuaiLe] text-2xl">四年+</p>
              <p className="text-xs text-primary-100">持续陪伴网友理性吃瓜</p>
            </div>
          </div>

          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">关于我们</span>
            <h2 className="mt-2 font-[ZCOOL_KuaiLe] text-3xl text-foreground-950">
              不只围观热闹，更做有温度的内容聚合
            </h2>
            <div className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
              <p>
                娜娜51热评圈定位于「聚焦娜娜51话题的网络热议内容聚合社区」，把贴吧、知乎、论坛与热搜中相关的高价值讨论集中呈现，让每一位感兴趣的朋友都能快速了解来龙去脉、围观观点交锋。
              </p>
              <p>
                我们相信，热闹背后值得被更理性、更友好地看待。因此团队坚持真实整理、客观归类、尊重原意，不传播未经核实的信息，不放大情绪化的对立，努力守护一块清爽的「吃瓜净土」。
              </p>
              <p>
                内容更新由人工与工具协同完成，覆盖话题热度、讨论趋势与精选评论，力求让你每一次打开都有新收获。
              </p>
            </div>

            <div className="mt-5 flex flex-wrap gap-2">
              {["真实整理", "理性客观", "友好氛围", "持续更新"].map((v) => (
                <span key={v} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-700">
                  {v}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14">
          <div className="text-center">
            <h3 className="font-[ZCOOL_KuaiLe] text-2xl text-foreground-950">来自围观群众的真实声音</h3>
          </div>
          <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-3">
            {reputationList.map((r) => (
              <figure key={r.user} className="rounded-2xl border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-600">“{r.text}”</blockquote>
                <figcaption className="mt-4 flex items-center justify-between">
                  <span className="text-sm font-semibold text-foreground-900">{r.user}</span>
                  <span className="rounded-full bg-background-100 px-2.5 py-1 text-[11px] text-foreground-500">{r.tag}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}